(() => {
  angular
    .module('gm.common.services')
    .factory('gmSignUpHelper', gmSignUpHelperFactory);

  function gmSignUpHelperFactory() {
    'ngInject';

    const USER_ALREADY_EXISTS = 'user.already.exists';
    const USER_REGISTRATION_RESTRICTED = 'user.not.allowed.registration';

    return {
      processSignUpErrors,
      resetFormErrors,
    };

    function processSignUpErrors(form, error, scope) {
      if (error && error.data && error.data.message) {
        switch (error.data.message) {
          case USER_ALREADY_EXISTS:
            form.$setValidity('conflict', false);
            break;

          case USER_REGISTRATION_RESTRICTED:
            form.$setValidity('restricted', false);
            break;

          default:
            form.$setValidity('server', false);
            break;
        }
      } else {
        form.$setValidity('unknown', false);
      }

      scope.$emit('gm:captcha:reset');
    }

    function resetFormErrors(form) {
      form.$setValidity('conflict', true);
      form.$setValidity('restricted', true);
      form.$setValidity('server', true);
      form.$setValidity('unknown', true);
    }
  }
})();
